/**
 * @file: 类型 和 状态 显示标签
 *
 * @author: FJJ
 * @history:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2023/08/29      1.0     First version
 *
 *
 * Copyright 2022, all rights reserved. Essa.cn
 * */
import React  from "react";
import "./label.less"
import {symbolMoneyUtil} from '@utils/utils';
/**
 * 状态 标签
 *  平台 状态；1：审核中（待处理），2：待赔付，3：已拒绝，4：撤销申请，5：已赔付 7:待客户处理
 *
 * 	工作台状态：statusMg 1:待处理 2:审核通过 3:已驳回 4:已撤销 5:已赔付 6:已失效 7:待汇款 8:已关闭 9:已发起
 * */
const StatusLabel = ({statusCode="",status="",className=""}) => {
    return (<span className={`labelSpan${className?" "+className:""}${statusCode=="5"?" labelSuccess":""}${(statusCode=="3"||statusCode=="7")?" labelWait":""}${statusCode=="2"||statusCode=="1"||statusCode=="9"?" labelIng":""}`}>
                                                   {status}
                                               </span>)
}

/**
 * 类型 标签
 * 索赔类型：damaged：破损，disable：买贵，arrive_late：晚到
 *
 * */
const TypeLabel =({typeCode="",type="",className=""})=> {
    return <span className={`typeLabel${className?" "+className:""}${typeCode=="arrive_late"?" typeLabelLate":""}${typeCode=="disable"?" typeLabelPurple":""}`}>{type}</span>
}



export {StatusLabel, TypeLabel,};

